import { UserDetailsEffects } from "@users/store/effects/user-details.effects";
import { UserSearchEffects } from "@users/store/effects/user-search.effects";

export const effects = [UserSearchEffects, UserDetailsEffects];

export * from "@users/store/effects/user-search.effects";
export * from "@users/store/effects/user-details.effects";
